export default __webpack_public_path__ + "static/media/reveal2.caab41cb.png";